module.exports = __webpack_public_path__ + "static/media/genero.13859440.png";